import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const BodyContainer = styled.div`
  max-width: 300px;
  padding: ${spacing.majorScale(1)}px ${spacing.majorScale(2)}px;
`

export const QuestionIconContainer = styled.div`
  cursor: pointer;
  height: 18px;
  width: 18px;
`
